import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-black" }
const _hoisted_2 = { class: "flex justify-between items-center mb-5" }
const _hoisted_3 = { class: "flex flex-col gap-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_FormQuiz = _resolveComponent("FormQuiz")!
  const _component_Questions = _resolveComponent("Questions")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("objectives.titles.quiz")), 1),
      (_ctx.role === 'TEACHER')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            id: "finalize-quiz",
            label: _ctx.$t('labels.finalize'),
            loading: _ctx.loading,
            disabled: _ctx.course?.type === 'ADAPTATIVE' ? !_ctx.actualId : false,
            class: "btn-primary p-button-sm",
            onClick: _ctx.goToChapters
          }, null, 8, ["label", "loading", "disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FormQuiz, {
        course: _ctx.course,
        data: _ctx.data,
        objective: _ctx.objective,
        role: _ctx.role,
        onOnAllow: _ctx.onAllow,
        onOnCreated: _ctx.getId
      }, null, 8, ["course", "data", "objective", "role", "onOnAllow", "onOnCreated"]),
      _createVNode(_component_Questions, {
        questions: _ctx.questions,
        quizId: _ctx.data?.id ?? _ctx.actualId,
        role: _ctx.role,
        objective: _ctx.objective
      }, null, 8, ["questions", "quizId", "role", "objective"])
    ])
  ]))
}